<template>
    <div class="bg-white px-3 index">
        <div class="add_tits" ref="title">
            <el-form class="form-inlines u-f  u-jsb " :inline="true">

                <div>
                    <el-form-item label="模糊搜索">
                        <el-input v-model="titles" placeholder="请输入内容" clearable size="small"></el-input>
                    </el-form-item>
                    <el-form-item label="">
                        <el-select v-model="type" placeholder="请选择类型" size="small">
                            <el-option label="系统消息" :value="1"></el-option>
                            <el-option label="热门推荐" :value="2"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item>
                        <el-button type="primary" icon="el-icon-search" size="small" @click="begin">搜索</el-button>
                    </el-form-item>

                </div>
                <div>
                    <el-form-item>
                        <el-button type="primary" icon="el-icon-circle-plus-outline" size="small" @click="add">新增
                        </el-button>
                    </el-form-item>
                </div>

            </el-form>
        </div>
        <div class="ibox-content">
            <el-table :data="tableData" border v-loading="loading" :height="heights" ref="configurationTable">
                <el-table-column prop="notice_title" label="通知名称" show-overfl ow-tooltip> </el-table-column>
                <el-table-column prop="notice_content" label="通知内容" show-overflow-tooltip> </el-table-column>
                <el-table-column prop="notice_content" label="类型" show-overflow-tooltip>
                    <template slot-scope="{row}">
                        {{({1:'系统消息',2:'热门推荐'})[row.type]}}
                    </template>
                </el-table-column>
                <el-table-column prop="create_time" label="创建时间" show-overflow-tooltip width="180"> </el-table-column>
                <el-table-column prop="read_count" label="查看量" show-overflow-tooltip width="80">
                    <template slot-scope="scope">
                        {{scope.row.read_count}} <span class="xq" title="查看详情" @click="openlode(scope.row.id)">详情</span>
                    </template>
                </el-table-column>
                <el-table-column label="操作" width="150">
                    <template slot-scope="scope">
                        <el-button size="mini" type="primary" @click="handleEdit(scope.$index, scope.row)">编辑
                        </el-button>
                        <el-button size="mini" type="danger" @click="handleDel(scope.$index, scope.row)">删除
                        </el-button>
                    </template>
                </el-table-column>
            </el-table>
            <div class="u-f u-ac u-jsb ft_mr">
                <div></div>
                <div>
                    <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                        :current-page="currentPage" :page-sizes="[10, 20, 30, 40]" :page-size="pagesize"
                        layout="total, sizes, prev, pager, next, jumper" :total="count">
                    </el-pagination>
                </div>
            </div>
        </div>
        <!-- 设置 -->
        <el-dialog title="系统通知设置" width="80%" :visible.sync="dialoged" @close='closedialo' top="20px" center
            :close-on-click-modal='false' class="dialogs">
            <el-divider></el-divider>
            <div class="dialog-ibox-content">
                <el-form ref="forms" :model="forms" :rules="rules" label-width="140px" class="demo-ruleForm">
                    <el-form-item label="类型">
                        <el-select v-model="forms.type" placeholder="请选择" size="small" @change="changetype">
                            <el-option label="系统消息" :value="1"></el-option>
                            <el-option label="热门推荐" :value="2"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="通知名称" prop="zs_value">
                        <el-input size="small" v-model="forms.zs_value" placeholder="（服务名称）"></el-input>
                    </el-form-item>
                    <el-form-item label="封面" v-if="forms.type==2">
                        <el-upload class="avatar-uploader" action="/admin/uploadFile" name="img" ref="upload"
                            :headers="{ token:$store.state.user.token }" :data="{ image_class_id:'72',file_type:'1'}"
                            :file-list="forms.lb_mapList" :on-success="uploadSuccess" :on-remove="uploadRmove"
                            list-type="picture-card">
                            <i class="el-icon-plus"></i>
                            <!-- verification:1,fileS:2,fileH:300,fileW:300  -->
                        </el-upload>
                    </el-form-item>
                    <el-form-item label="通知简介" prop="brief">
                        <el-input size="small" v-model="forms.brief" type="textarea" :rows="2"
                            placeholder="请输入通知简介（头部简介）">
                        </el-input>
                    </el-form-item>
                    <el-form-item label="通知内容" prop="problem" :rules="{
                        required: forms.type==1,
                        message: '请填写通知内容',
                        trigger: 'blur'
                    }">
                        <el-input size="small" v-model="forms.problem" type="textarea" :rows="3" placeholder="请输入通知内容">
                        </el-input>
                    </el-form-item>
                    <el-form-item label="发送方式" prop="problem">
                        <el-radio v-model="sendradio" :label="2">人员</el-radio>
                        <el-radio v-model="sendradio" :label="1">用户组</el-radio>
                    </el-form-item>
                    <el-form-item :label="sendradio==1?'选择组':'选择人员'">
                        <div class="u-f u-ac">
                            <el-form-item v-if="sendradio!=1">
                                <el-input v-model="userkeyword" placeholder="请输入昵称、手机号" style="width:200px" clearable
                                    size="small"></el-input>
                            </el-form-item>
                            <div class="pd">
                                <el-form-item>
                                    <el-select v-model="lb_value" clearable placeholder="请选择人员类型" size="small"
                                        filterable>
                                        <el-option v-for="item in  lb_options" :key="item.id" :label="item.name"
                                            :value="item.id">
                                        </el-option>
                                    </el-select>
                                </el-form-item>
                            </div>
                            <el-form-item v-if="sendradio==1">

                                <span style="color:red;padding:5px 0;font-size:13px">(选择发送给所属类别人员)</span>
                            </el-form-item>
                            <el-form-item v-if="sendradio!=1">
                                <el-button type="primary" icon="el-icon-search" size="small" @click="searchusers">搜索
                                </el-button>
                                <span style="color:red;padding:5px 0;font-size:13px">(不选则全体通知)</span>
                            </el-form-item>
                        </div>
                        <div v-if="sendradio!=1">
                            <div class="u-f">


                                <div style="width:50%">
                                    <el-table :data="userTableData" border v-loading="loading" height="430"
                                        ref="configurationTables" @selection-change="handleSelectionChange"
                                        :row-key="getRowKeys">
                                        <el-table-column type="selection" width="55" :reserve-selection="true" />
                                        <el-table-column prop="title" label="头像" show-overfl ow-tooltip>
                                            <template slot-scope="scope">
                                                <el-image style="width: 50px; height: 50px"
                                                    :src="scope.row.doctorAudit?scope.row.doctorAudit.head_portrait_pic[0].url:scope.row.avatar"
                                                    fit="cover">
                                                </el-image>
                                            </template>
                                        </el-table-column>
                                        <el-table-column prop="live_broadcast" label="用户名" show-overflow-tooltip>
                                            <template slot-scope="scope">
                                                <span>{{scope.row.doctorAudit?scope.row.doctorAudit.real_name:scope.row.nickname}}</span>
                                            </template>
                                        </el-table-column>
                                    </el-table>

                                </div>
                                <div style="width:50%;margin-left:10px">
                                    <el-table :data="sendusers" border v-loading="loading" height="430"
                                        ref="configurationTable">
                                        <el-table-column prop="title" label="头像" show-overfl ow-tooltip>
                                            <template slot-scope="scope">
                                                <el-image style="width: 50px; height: 50px"
                                                    :src="scope.row.doctorAudit?scope.row.doctorAudit.head_portrait_pic[0].url:scope.row.avatar"
                                                    fit="cover">
                                                </el-image>
                                            </template>
                                        </el-table-column>
                                        <el-table-column prop="live_broadcast" label="用户名" show-overflow-tooltip>
                                            <template slot-scope="scope">
                                                <span>{{scope.row.doctorAudit?scope.row.doctorAudit.real_name:scope.row.nickname}}</span>
                                            </template>
                                        </el-table-column>
                                    </el-table>
                                </div>
                            </div>
                            <div class="u-f u-ac u-jsb ft_mr">
                                <div>
                                    <el-pagination @size-change="userhandleSizeChange"
                                        @current-change="userhandleCurrentChange" :current-page="usercurrentPage"
                                        :page-sizes="[10, 20, 30, 40]" :page-size="userpagesize"
                                        layout="total, sizes, prev, pager, next, jumper" :total="usercount">
                                    </el-pagination>
                                </div>
                            </div>
                        </div>
                    </el-form-item>
                    <el-form-item label="立即推送">
                        <el-radio v-model="push" :label="0">否</el-radio>
                        <el-radio v-model="push" :label="1">是</el-radio>
                    </el-form-item>
                    <el-form-item label="活动链接" :rules="{
                        required: forms.type==2,
                        message: '请填写跳转链接',
                        trigger: 'blur'
                    }" prop="url">
                        <el-input size="small" v-model="forms.url" style="max-width:500px"></el-input>
                        <span v-if="forms.type==1" style="color:red">不填则跳转至活动详情页面</span>
                    </el-form-item>
                </el-form>
            </div>
            <el-divider></el-divider>
            <span slot="footer" class="dialog-footer">
                <el-button type="primary" @click="submited('forms')" :loading='sendacloading' size="small">确 定
                </el-button>
                <el-button @click="dialoged = false" size="small">取 消</el-button>
            </span>
        </el-dialog>
        <!-- 查看量 -->
        <el-dialog title="已查看" width="50%" :visible.sync="lookdialoged" top="20px" center class="dialogs">
            <el-divider></el-divider>
            <div class="dialog-ibox-content">
                <div class="ibox-content">
                    <el-table :data="looktableData" border v-loading="loading" :height="heights"
                        ref="configurationTable">
                        <el-table-column prop="user_name" label="用户名" show-overfl ow-tooltip> </el-table-column>
                        <el-table-column prop="introduction" label="头像" show-overflow-tooltip>
                            <template slot-scope="scope">
                                <img :src="scope.row.user_avatar" alt="" width="80">
                            </template>
                        </el-table-column>
                        <el-table-column prop="create_time" label="时间" show-overflow-tooltip width="180">
                        </el-table-column>
                    </el-table>
                    <div class="u-f u-ac u-jsb ft_mr">
                        <div></div>
                        <div>
                            <el-pagination @size-change="lookhandleSizeChange" @current-change="lookhandleCurrentChange"
                                :current-page="lookcurrentPage" :page-sizes="[10, 20, 30, 40]" :page-size="lookpagesize"
                                layout="total, sizes, prev, pager, next, jumper" :total="lookcount">
                            </el-pagination>
                        </div>
                    </div>
                </div>
            </div>
            <el-divider></el-divider>
            <span slot="footer" class="dialog-footer">
                <el-button @click="lookdialoged = false" size="small">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>


<script>
    import {
        mapState
    } from 'vuex'
    export default {
        data() {
            return {
                sendradio: 2,
                lookdialoged: false,
                looktableData: [],
                lookcount: 0,
                lookcurrentPage: 1,
                lookpagesize: 10,
                luId: '',
                resource_id: 'p_5fdb0346e4b0231ba88d4839',
                resource_type: '4',
                dialog: false,
                titles: '',
                loading: false,
                tableData: [],
                userTableData: [],
                seleteUserTableData: [],
                currentPage: 1,
                pagesize: 10,
                usercurrentPage: 1,
                userpagesize: 10,
                usercount: 0,
                userkeyword: '',
                count: 0,
                heights: null,

                // 
                eid: '',
                dialoged: false,
                lb_value: '',
                lb_options: [{
                    id: 1,
                    name: '普通用户'
                }, {
                    id: 2,
                    name: '医生'
                }, {
                    id: 3,
                    name: '心理医生'
                }],
                forms: {
                    problem: '',
                    zs_value: '',
                    brief: '',
                    url: '',
                    type: 1,
                    lb_mapList: []
                },
                mapListed: [],
                rules: {
                    zs_value: [{
                        required: true,
                        message: '请填写通知名称',
                        trigger: 'blur'
                    }],
                    brief: [{
                        required: true,
                        message: '请填写通知简介',
                        trigger: 'blur'
                    }],
                    problem: [{
                        required: true,
                        message: '请填写通知内容',
                        trigger: 'blur'
                    }],
                    url: [{
                        required: true,
                        message: '请填写跳转链接',
                        trigger: 'blur'
                    }]
                },
                listItem: [],
                arrxq: '',
                sendusers: [],
                push: 0,
                sendacloading: false,
                type: 1
            };
        },
        computed: {
            ...mapState({
                user: state => state.user.user,
            })
        },
        mounted() {
            let that = this
            that.getHeight()
            that.begin()
            that.searchusers()
        },
        methods: {
            // 获取高度
            getHeight() {
                let that = this;
                var title = that.$refs.title.offsetHeight
                that.heights = window.innerHeight - title - 220 + 'px'
                window.onresize = () => {
                    var title = that.$refs.title.offsetHeight
                    that.heights = window.innerHeight - title - 220 + 'px'
                }
            },
            begin() {
                let that = this
                that.currentPage = 1
                that.pagesize = 10
                that.search()
            },
            search() {
                let that = this
                that.loading = true
                axios
                    .post("/admin/SystemNotification/notificationlist", {
                        page: that.currentPage,
                        page_count: that.pagesize,
                        keyword: this.titles,
                        type: this.type

                    }, {
                        token: true
                    })
                    .then(response => {
                        that.loading = false
                        that.tableData = response.data.data.list
                        that.count = response.data.data.count

                    })
                    .catch(error => {})
            },

            searchusers() {
                let that = this
                that.loading = true
                axios
                    .post("/admin/User/userList", {
                        page: that.usercurrentPage,
                        limit: that.userpagesize,
                        keyword: this.userkeyword,
                        customer_type: this.lb_value

                    }, {
                        token: true
                    })
                    .then(response => {
                        that.loading = false
                        that.userTableData = response.data.data.list
                        that.usercount = response.data.data.totalCount

                    })
                    .catch(error => {})
            },

            handleSizeChange(val) {
                let that = this
                that.pagesize = val;
                that.search()
            },
            handleCurrentChange(val) {
                let that = this
                that.currentPage = val;
                that.search()
            },
            lookhandleSizeChange(val) {
                let that = this
                that.lookpagesize = val;
                this.getlookuser()
            },
            lookhandleCurrentChange(val) {
                let that = this
                that.lookcurrentPage = val;
                this.getlookuser()
            },
            openlode(id) {
                this.lookdialoged = true
                this.luId = id
                this.getlookuser()
            },

            getlookuser() {
                let that = this
                that.loading = true
                axios
                    .post("/admin/SystemReadRecord/historyRead", {
                        page: that.lookcurrentPage,
                        page_count: that.lookpagesize,
                        id: this.luId,
                        source: 1,

                    }, {
                        token: true
                    })
                    .then(response => {
                        that.loading = false
                        that.looktableData = response.data.data.data
                        that.lookcount = response.data.data.count

                    })
                    .catch(error => {})
            },
            getRowKeys(row) {
                return row.id; // id为列表数据的唯一标识
            },
            userhandleSizeChange(val) {
                let that = this
                that.userpagesize = val;
                that.searchusers()
            },
            userhandleCurrentChange(val) {
                let that = this
                that.usercurrentPage = val;
                that.searchusers()
            },
            // 新增
            add() {
                let that = this
                this.clear()
                that.dialoged = true
                that.eid = ''
                that.forms.zs_value = ''
                that.forms.problem = ''
                that.forms.brief = ''
                that.forms.url = ''
                this.forms.type=1
                this.forms.lb_mapList=[]
                this.mapListed=[]
                that.searchusers()

            },
            clear() {
                this.sendradio = 2
            },
            changetype(a) {
                this.mapListed = []
                this.forms.lb_mapList = []
            },
            uploadSuccess(response, file, fileList) {
                let that = this
                if (response.code == "201") {
                    that.$nextTick(() => {
                        let mainImg = that.$refs.upload;
                        if (mainImg) {
                            mainImg.uploadFiles.forEach((element, index) => {
                                if (file.uid == element.uid) {
                                    mainImg.uploadFiles.splice(index, 1)
                                }
                            });
                        }
                    })
                    that.$alert(response.msg)
                    return;
                }
                that.$message({
                    message: '上传成功',
                    type: 'success'
                });
                that.mapListed.push(response.data)
            },
            uploadRmove(file, fileList) {
                var index = this.mapListed.findIndex(item => item.id == file.id)
                this.mapListed.splice(index, 1)
            },
            // 设置
            submited(formName) {
                let that = this
                if (!that.forms.zs_value) return this.$message.error('请填写标题')
                if (!that.forms.brief) return this.$message.error('请填写简介')
                if (this.forms.type==1&&!that.forms.problem) return this.$message.error('请填写内容')
                if (this.forms.type==2&&this.forms.url=='') return this.$message('请输入跳转的链接地址')
                let userids = []
                this.sendusers.forEach(ele => {
                    userids.push(ele.id)
                });
                let cover = this.mapListed.length > 0 ? this.mapListed[0].url : ''
                if (this.sendradio == 2) {
                    var params = {
                        id: that.eid,
                        author: this.user.id,
                        notice_title: that.forms.zs_value,
                        notice_content: that.forms.problem,
                        receiver: (userids && userids.length > 0) ? userids.toString() : 0,
                        introduction: that.forms.brief,

                        send_type: this.sendradio,
                        url: that.forms.url,
                        push: this.push,
                        type: this.forms.type,
                        cover: cover
                    }
                    var params2 = {

                        author: this.user.id,
                        notice_title: that.forms.zs_value,
                        notice_content: that.forms.problem,
                        receiver: (userids && userids.length > 0) ? userids.toString() : 0,
                        introduction: that.forms.brief,
                        send_type: this.sendradio,
                        url: that.forms.url,
                        push: this.push,
                        type: this.forms.type,
                        cover: cover
                    }
                } else {
                    if (!this.lb_value) {
                        this.$message.error('请选择所属类别人员')
                        return
                    }
                    var params = {

                        id: that.eid,
                        author: this.user.id,
                        notice_title: that.forms.zs_value,
                        notice_content: that.forms.problem,
                        // receiver: (userids && userids.length > 0) ? userids.toString() : 0,
                        introduction: that.forms.brief,

                        send_type: this.sendradio,
                        receiver_type: this.lb_value,
                        push: this.push,
                        url: that.forms.url,
                        type: this.forms.type,
                        cover: cover


                    }
                    var params2 = {

                        author: this.user.id,
                        notice_title: that.forms.zs_value,
                        notice_content: that.forms.problem,
                        // receiver: (userids && userids.length > 0) ? userids.toString() : 0,
                        introduction: that.forms.brief,
                        send_type: this.sendradio,
                        receiver_type: this.lb_value,
                        push: this.push,
                        url: that.forms.url,
                        type: this.forms.type,
                        cover: cover

                    }
                }
                if (this.sendradio == 2 && this.lb_value == '' && this.sendusers.length == 0) {
                    this.$confirm('你未选择任何用户，这将发送给全部用户, 是否继续?', '提示', {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        type: 'warning'
                    }).then(() => {
                        this.subnithand(params, params2)
                    }).catch(() => {
                        this.$message({
                            type: 'info',
                            message: '已取消删除'
                        });
                    });
                } else {
                    this.subnithand(params, params2)
                }


            },
            subnithand(params, params2) {
                let that = this
                this.sendacloading = true
                if (this.eid) {
                    axios
                        .post("/admin/SystemNotification/update", params, {
                            token: true
                        })
                        .then(response => {
                            if (response.data.code == 200) {
                                this.dialoged = false
                                this.search()
                                this.$message("操作成功")
                            } else {
                                this.$message.error(response.data.msg)
                            }
                            this.sendacloading = false

                        })
                        .catch(error => {
                            this.sendacloading = false
                        })
                } else {
                    axios
                        .post("/admin/SystemNotification/save", params2, {
                            token: true
                        })
                        .then(response => {
                            if (response.data.code == 200) {
                                this.dialoged = false
                                this.search()
                                this.$message("操作成功")
                            } else {
                                this.$message.error(response.data.msg)
                            }
                            this.sendacloading = false

                        })
                        .catch(error => {
                            this.sendacloading = false
                        })
                }
            },
            handleEdit(index, row) {
                let that = this
                this.clear()
                that.dialoged = true
                that.eid = row.id
                that.forms.zs_value = row.notice_title
                that.forms.problem = row.notice_content
                that.forms.brief = row.introduction
                that.forms.url = row.url
                that.forms.type = row.type
                that.searchusers()
                this.$nextTick(() => {
                    this.$refs.configurationTables.clearSelection();

                })

            },
            handleDel(index, row) {
                this.$confirm('此操作将永久删除该文件, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    axios
                        .post("/admin/SystemNotification/del", {
                            id: row.id
                        }, {
                            token: true
                        })
                        .then(response => {
                            if (response.data.code == 200) {
                                this.$message({
                                    type: 'success',
                                    message: '删除成功!'
                                });
                                this.begin()
                            }

                        })
                        .catch(error => {})

                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消删除'
                    });
                });

            },
            handleSelectionChange(val) {
                this.sendusers = val;
            },
            closedialo() {
                this.userkeyword = ''
                this.sendusers = []
                if (this.sendradio == 2) {
                    this.$nextTick(() => {
                        this.$refs.configurationTables.clearSelection();
                    })
                }

            },

        },

    };
</script>


<style scoped>
    .pd {
        padding: 0 10px
    }

    .editors {
        height: 300px;

    }

    .editors>>>.tox-tinymce {
        height: 300px !important;
    }

    .xq {
        color: rgb(0, 147, 206);
        cursor: pointer;
    }
</style>